module.exports = __webpack_public_path__ + "img/icon-table-delete.a11fd84a.svg";